import React, { useEffect, useState } from "react";

const RoundTimer = ({
  currentRount,
  currentTime,
  setTimeshow,
  startTime11,
  history,
  timeshow,
}) => {
  const [day, setDay] = useState(0);
  const [hour, setHour] = useState(0);
  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);

  // console.log("=================", {currentRount, currentTime, startTime11, timeshow});

  useEffect(() => {
    const interval = setInterval(() => {
      let now = "";
      let time = "";
      let diff = "";
      if (currentTime < new Date(parseInt(currentRount?.startTime))) {
        now = new Date();
        time = new Date(parseInt(currentRount?.startTime));
        diff = time.getTime() - parseInt(now.getTime() / 1000);
        setTimeshow(false);
      } else if (
        currentTime > new Date(parseInt(currentRount?.startTime)) &&
        currentTime < new Date(parseInt(currentRount?.endTime))
      ) {
        now = new Date();
        time = new Date(parseInt(currentRount?.endTime));
        diff = time.getTime() - parseInt(now.getTime() / 1000);
        setTimeshow(false);
        // console.log(diff);
      }
      if (diff <= 0) {
        if (currentTime < new Date(parseInt(currentRount?.startTime))) {
          window.location.reload();
        }
        clearInterval(interval);
        setTimeshow(true);
        // setPrice(0)
        // setId(null)
        // setRound(null)
      }
      const days = Math.floor(diff / (60 * 60 * 24));
      const hours = Math.floor((diff % (60 * 60 * 24)) / (60 * 60));
      const mins = Math.floor((diff % (60 * 60)) / 60);
      const secs = Math.floor(diff % 60);
      setDay(days);
      setHour(hours);
      setMin(mins);
      setSec(secs);

      const currentTime11 = new Date();
      if (currentTime11 > new Date(startTime11)) {
        history.push("/");
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [currentRount]);

  return (
    <span className="innertimertext">
      {day ? day : 0}D : {hour ? hour : 0}H : {min ? min : 0}M : {sec ? sec : 0}
      S
    </span>
  );
};

export default RoundTimer;
